export default class AppHelper {
    public static applicationFromUrl(fallback: string = 'default'): string {
        const names = ['kantor', 'semco', 'tem', 'courius', 'fearless', 'ievp', 'pit', 'rjc', 'cta'];
        const aliases = {
            'team-energie': 'tem',
            'just-culture': 'rjc',
        };
        const applicationFromAlias = (value: string): string => {
            const normalizedValue = value?.toLowerCase();
            if (aliases[normalizedValue]) {
                return aliases[normalizedValue];
            }

            return names.find((name) => normalizedValue === name);
        };

        const firstSegment = window.location.pathname.split('/').filter(Boolean)[0];
        const applicationFromSegment = applicationFromAlias(firstSegment);
        if (applicationFromSegment) {
            return applicationFromSegment;
        }

        const hostname = window.location.hostname.toLowerCase();
        const applicationFromHost = names.find((name) => hostname.indexOf(name) > -1);
        if (applicationFromHost) {
            return applicationFromHost;
        }

        return applicationFromAlias(fallback) ?? fallback;
    }

    public static getApexFromUrl(): string {
        const hostname = window.location.hostname;
        const convertedDomains = ['fearlessorganization.com', 'brightinstruments.net'];
        for (const i in convertedDomains) {
            if (hostname.indexOf(convertedDomains[i]) > -1) {
                return convertedDomains[i];
            }
        }
        return 'brightinstruments.net';
    }
}
